import React, { Component } from 'react'
import { func, array, string, bool } from 'prop-types'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'

import { GardenersInfoText } from './GardenersInfoText'
import GardenerItem from './GardenerItem'
import { PostalCodePicker } from './PostalCodePicker'
import { stores, view } from '../../stores'

import { PagesPaths } from '../../constants/Pages'

import './Gardeners.css'

var MAX_GALLERY_IMAGES = 5

class GardenersComponent extends Component {
  constructor (props) {
    super(props)
    const {
      withInfoText, city, cityDescriptionHtml, titleHtml,
      metaDescription, metaTitle, pictureList,
      selected, jardiniers, onPostalCodeChange, withCode
    } = props
    this.state = {
      withInfoText, withCode, city, cityDescriptionHtml, titleHtml,
      metaDescription, metaTitle, pictureList,
      selected, onPostalCodeChange, jardiniers,
      lightboxOpen: false,
      lightboxIndex: 0,
      showNoSelectionModal: false
    }
    this.openLightbox = this.openLightbox.bind(this)
    this.closeLightbox = this.closeLightbox.bind(this)
    this.handleMakeRequest = this.handleMakeRequest.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.lightboxPrev = this.lightboxPrev.bind(this)
    this.lightboxNext = this.lightboxNext.bind(this)
    this.handleLightboxKey = this.handleLightboxKey.bind(this)
  }

  componentWillUnmount () {
    document.removeEventListener('keydown', this.handleLightboxKey)
    document.body.style.overflow = ''
  }

  openLightbox (index) {
    this.setState({ lightboxOpen: true, lightboxIndex: index })
    document.addEventListener('keydown', this.handleLightboxKey)
    document.body.style.overflow = 'hidden'
  }

  closeLightbox () {
    this.setState({ lightboxOpen: false })
    document.removeEventListener('keydown', this.handleLightboxKey)
    document.body.style.overflow = ''
  }

  lightboxPrev () {
    var total = (this.state.pictureList || []).length
    this.setState(function (s) { return { lightboxIndex: (s.lightboxIndex - 1 + total) % total } })
  }

  lightboxNext () {
    var total = (this.state.pictureList || []).length
    this.setState(function (s) { return { lightboxIndex: (s.lightboxIndex + 1) % total } })
  }

  handleLightboxKey (e) {
    if (e.key === 'Escape') this.closeLightbox()
    if (e.key === 'ArrowLeft') this.lightboxPrev()
    if (e.key === 'ArrowRight') this.lightboxNext()
  }

  handleMakeRequest () {
    if (stores.search.selected.length === 0) {
      this.setState({ showNoSelectionModal: true })
    } else {
      this.props.history.push(PagesPaths.INQUIRY.path)
    }
  }

  closeModal () {
    this.setState({ showNoSelectionModal: false })
  }

  renderNoSelectionModal () {
    if (!this.state.showNoSelectionModal) return null
    var self = this
    return (
      <div className="gardeners-listing__modal-overlay" onClick={this.closeModal}>
        <div className="gardeners-listing__modal" onClick={function (e) { e.stopPropagation() }}>
          <button className="gardeners-listing__modal-close" onClick={this.closeModal} aria-label="Fermer">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          </button>
          <div className="gardeners-listing__modal-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#009d3d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4-4v-2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" />
            </svg>
          </div>
          <h3 className="gardeners-listing__modal-title">Aucun jardinier sélectionné</h3>
          <p className="gardeners-listing__modal-text">Cliquez sur les fiches des jardiniers qui vous intéressent pour les sélectionner, ou continuez directement vers votre demande.</p>
          <div className="gardeners-listing__modal-actions">
            <button className="gardeners-listing__modal-btn gardeners-listing__modal-btn--primary" onClick={this.closeModal}>
              Choisir un jardinier
            </button>
            <button className="gardeners-listing__modal-btn gardeners-listing__modal-btn--secondary" onClick={function () { self.closeModal(); self.props.history.push(PagesPaths.INQUIRY.path) }}>
              Continuer sans sélection
            </button>
          </div>
        </div>
      </div>
    )
  }

  renderLightbox () {
    if (!this.state.lightboxOpen) return null
    var pics = this.state.pictureList || []
    var current = pics[this.state.lightboxIndex]
    if (!current) return null
    var total = pics.length
    var index = this.state.lightboxIndex

    return (
      <div className="gardeners-listing__lightbox" onClick={this.closeLightbox}>
        <div className="gardeners-listing__lightbox-content" onClick={function (e) { e.stopPropagation() }}>
          <img className="gardeners-listing__lightbox-media" src={current.file.path} alt={current.altTag} />
          {total > 1 && (
            <button className="gardeners-listing__lightbox-nav gardeners-listing__lightbox-nav--prev" onClick={this.lightboxPrev} aria-label="Photo précédente">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            </button>
          )}
          {total > 1 && (
            <button className="gardeners-listing__lightbox-nav gardeners-listing__lightbox-nav--next" onClick={this.lightboxNext} aria-label="Photo suivante">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
            </button>
          )}
          <div className="gardeners-listing__lightbox-counter">{(index + 1) + ' / ' + total}</div>
        </div>
        <button className="gardeners-listing__lightbox-close" onClick={this.closeLightbox} aria-label="Fermer">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
        </button>
      </div>
    )
  }

  renderGallery () {
    var pictureList = this.state.pictureList
    if (!this.state.withInfoText || !pictureList || pictureList.length === 0) return null

    var total = pictureList.length
    var visible = pictureList.slice(0, MAX_GALLERY_IMAGES)
    var visibleCount = visible.length
    var galleryClass = 'gardeners-listing__gallery gardeners-listing__gallery--count-' + Math.min(visibleCount, 5)

    var self = this

    return (
      <div className={galleryClass}>
        {visible.map(function (pic, i) {
          var isLast = i === visibleCount - 1 && total > MAX_GALLERY_IMAGES
          return (
            <div key={i} className="gardeners-listing__gallery-item" onClick={function () { self.openLightbox(i) }} style={{ cursor: 'pointer' }}>
              <img
                src={pic.file.path}
                alt={pic.altTag}
                title={pic.altTag}
                loading="lazy"
              />
              {i === 0 && total > 1 && (
                <div className="gardeners-listing__gallery-count">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" /></svg>
                  {total + ' photos'}
                </div>
              )}
              {isLast && (
                <div className="gardeners-listing__gallery-more">
                  +{total - MAX_GALLERY_IMAGES}
                </div>
              )}
            </div>
          )
        })}
      </div>
    )
  }

  render () {
    const {
      withInfoText, city, cityDescriptionHtml, titleHtml,
      metaDescription, metaTitle, jardiniers, onPostalCodeChange
    } = this.state

    var postalCode = stores.search.search.postalCode
    var hasMultipleCodes = stores.search.search.allPostalCodesOfCity && stores.search.search.allPostalCodesOfCity.length > 1
    var count = jardiniers ? jardiniers.length : 0

    if (!withInfoText) {
      // Tunnel /demande — cards only, no city content
      return (
        <div className="gardeners-listing">
          <div className="gardeners-listing__cards-only">
            {jardiniers.map(function (jardinier) {
              return <GardenerItem key={jardinier.id} jardinier={jardinier} />
            })}
          </div>
        </div>
      )
    }

    return (
      <div className="gardeners-listing">
        <div className="gardeners-listing__layout">
          {/* Left column — city content */}
          <div className="gardeners-listing__left">
            {/* Hero */}
            <div className="gardeners-listing__hero">
              {titleHtml
                ? <div className="city-description" dangerouslySetInnerHTML={{ __html: titleHtml }} />
                : <h1 className="gardeners-listing__title">
                    {city
                      ? 'Jardiniers paysagistes à ' + city
                      : 'Trouvez votre jardinier paysagiste'
                    }
                  </h1>
              }
              {city && postalCode && (
                <div className="gardeners-listing__subtitle">
                  {count} jardinier{count > 1 ? 's' : ''} disponible{count > 1 ? 's' : ''} à {city} ({postalCode})
                </div>
              )}
              {hasMultipleCodes && (
                <div className="gardeners-listing__cp-hint">
                  <span className="gardeners-listing__cp-hint-text">{city} comporte plusieurs codes postaux, vous pouvez switch facilement ici, sélectionnez bien le vôtre :</span>
                  <PostalCodePicker
                    postalCodes={stores.search.search.allPostalCodesOfCity}
                    selected={postalCode}
                    onChange={onPostalCodeChange}
                  />
                </div>
              )}
            </div>

            {/* City gallery */}
            {this.renderGallery()}

            {/* CTA */}
            <div className="gardeners-listing__cta">
              <div className="gardeners-listing__cta-text">Un jardin qui vous ressemble</div>
              <div className="gardeners-listing__cta-sub">Devis gratuit · Crédit d'impôt 50% · Réponse sous 48h</div>
              <button className="btn--lined" onClick={this.handleMakeRequest}>Faire ma demande</button>
            </div>

            {/* SEO content */}
            <div className="gardeners-listing__seo">
              <GardenersInfoText
                city={city}
                cityDescriptionHtml={cityDescriptionHtml}
                titleHtml={titleHtml}
                metaDescription={metaDescription}
                metaTitle={metaTitle}
                zipCodes={stores.search.search.allPostalCodesOfCity}
                selectedPostalCode={postalCode}
              />
            </div>
          </div>

          {/* Right column — cards */}
          <div className="gardeners-listing__right">
            <div className="gardeners-listing__count">
              <b>{count}</b> jardinier{count > 1 ? 's' : ''} à {city}
            </div>
            <div className="gardeners-listing__select-hint">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
              <span>
                {stores.search.selected.length > 0
                  ? stores.search.selected.length + ' jardinier' + (stores.search.selected.length > 1 ? 's' : '') + ' sélectionné' + (stores.search.selected.length > 1 ? 's' : '')
                  : 'Cliquez sur une fiche pour sélectionner un jardinier'
                }
              </span>
              {stores.search.selected.length > 1 && (
                <button className="gardeners-listing__deselect-btn" onClick={function (e) { e.stopPropagation(); stores.search.deselectAll() }}>
                  Tout désélectionner
                </button>
              )}
            </div>
            {jardiniers.map(function (jardinier) {
              return <GardenerItem key={jardinier.id} jardinier={jardinier} />
            })}
            {/* Bottom CTA in cards column */}
            <div className="gardeners-listing__cta-bottom">
              <button className="btn--lined" onClick={this.handleMakeRequest}>Faire ma demande</button>
            </div>
          </div>
        </div>
        {/* Mobile sticky bar */}
        <div className="gardeners-listing__mobile-bar">
          <button className="gardeners-listing__mobile-bar-scroll" onClick={function () {
            var el = document.querySelector('.gardeners-listing__right')
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }}>
            {stores.search.selected.length > 0
              ? stores.search.selected.length + ' sélectionné' + (stores.search.selected.length > 1 ? 's' : '')
              : 'Voir les jardiniers'
            }
          </button>
          <button className="gardeners-listing__mobile-bar-cta" onClick={this.handleMakeRequest}>
            Faire ma demande
          </button>
        </div>
        {this.renderLightbox()}
        {this.renderNoSelectionModal()}
      </div>
    )
  }
}

GardenersComponent.propTypes = {
  city: string,
  cityDescriptionHtml: string,
  titleHtml: string,
  metaDescription: string,
  metaTitle: string,
  pictureList: array,
  jardiniers: array,
  selected: array,
  t: func,
  onPostalCodeChange: func,
  withInfoText: bool,
  withCode: bool
}

GardenersComponent.defaultProps = {
  withInfoText: false
}

export const Gardeners = withRouter(translate()(view(GardenersComponent)))



// WEBPACK FOOTER //
// ./src/components/gardeners/Gardeners.js